import { useMutation, useQuery } from '@tanstack/react-query';
import { IGlobalVariable } from '../../Interfaces/IGlobalVariable';
import { customFetcher } from '../useFetch';

export const useGetGlobalVariables = () => {
  const {
    data: globalVariables,
    isLoading: isLoadingGlobalVariables,
    refetch: refetechGlobalVariables,
  } = useQuery<IGlobalVariable[]>({
    queryKey: ['globalvariable'],
    queryFn: () => customFetcher({ endpoint: '/globalvariable' }),
  });

  return { globalVariables, isLoadingGlobalVariables, refetechGlobalVariables };
};

export const useWriteGlobalVariable = () => {
  const {
    mutateAsync: writeGlobalVariable,
    isPending: isPendingWriteGlobalVariable,
  } = useMutation({
    mutationFn: (uploadObject: IGlobalVariable) =>
      customFetcher({
        endpoint: '/globalvariable',
        body: uploadObject,
        method: uploadObject.idGlobalVariable < 0 ? 'POST' : 'PUT',
      }),
  });

  return {
    writeGlobalVariable,
    isPendingWriteGlobalVariable,
  };
};

export const useDeleteGlobalVariable = () => {
  const {
    mutateAsync: deleteGlobalVariable,
    isPending: isPendingDeleteGlobalVariable,
  } = useMutation({
    mutationFn: (uploadObject: IGlobalVariable) =>
      customFetcher({
        endpoint: `/globalvariable/${uploadObject.idGlobalVariable}`,
        method: 'DELETE',
      }),
  });

  return {
    deleteGlobalVariable,
    isPendingDeleteGlobalVariable,
  };
};
